import * as yup from 'yup'

export const createEstateSchema = yup.object().shape({
  name: yup.string().required('Estate name is required'),
  address: yup.string().required('Estate address is required'),
})
